import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';
import FilterSearchIcon from '../../FilterSearchIcon';

const CreatedByDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('filter.createdBy')}
    labelKey="name"
    valueKey="oxygenId"
    selectClassName="IssueCreateForm__field-width"
    placeholder={T.translate('filter.createdByPlaceholder')}
    searchable
    searchIcon={<FilterSearchIcon />}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, ...CreatedByDropDownPropTypes } = DropDownPropTypes;

CreatedByDropDown.propTypes = CreatedByDropDownPropTypes;
export default CreatedByDropDown;
